import styled, { css } from "styled-components";
import { colors } from "../../../../utils";
import TextView from "../../../TextView";
import { ASSETS } from "../../../../utils/config";
import { Stack } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import NewHotbar from "../../../NewHotbar/NewHotbar";
import { Content, TabsWrapper } from "../../../NewHotbar/NewHotbar.styled";
import TabNavigation from "../../../NewHotbar/TabNavigation";
import ImagesTab from "../../../NewHotbar/Tabs/ImagesTab";
import VideosTab from "../../../NewHotbar/Tabs/VideosTab";
import DocumentsTab from "../../../NewHotbar/Tabs/DocumentsTab";
import AudiosTab from "../../../NewHotbar/Tabs/AudiosTab";
import LinksTab from "../../../NewHotbar/Tabs/LinksTab";
import { useState } from "react";

const Container = styled.div`
  min-width: 30vw;
  background-color: white;
  box-shadow: 0px 0px 9.3px 0px #3b3b3b1c;
  height: 92vh;
  display: flex;
  flex-direction: column;
  transform: translateX(100%);
  transition: transform 0.3s ease-in-out;
  ${({ isVisible }) =>
    isVisible &&
    css`
      transform: translateX(1px);
    `}
`;

const Header = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  padding: 24px 16px 10px 16px;
  border-bottom: 1px solid ${colors.lightBorder};
  justify-content: space-between;
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 10;
`;

const StickyTabsContainer = styled.div`
  position: sticky;
  top: 61px; /* Adjust based on your header height */
  background-color: white;
  z-index: 9;
  padding: 0 16px;
`;

const ScrollableContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0 16px 16px 16px;
`;

const HotbarBuilder = ({ isVisible, onClose }) => {
  const [activeTab, setActiveTab] = useState("images");

  const renderTabContent = () => {
    switch (activeTab) {
      case "images":
        return <ImagesTab />;
      case "videos":
        return <VideosTab />;
      case "documents":
        return <DocumentsTab />;
      case "audios":
        return <AudiosTab />;
      case "links":
        return <LinksTab />;
      default:
        return <ImagesTab />;
    }
  };

  return (
    <Container isVisible={isVisible}>
      <Header>
        <Stack direction={"row"}>
          <img src={ASSETS.segmentEditor.Hotbar} style={{ marginRight: 5 }} />
          <TextView variant="title" style={{ height: "100%" }}>
            Hotbar
          </TextView>
        </Stack>

        <CloseIcon
          sx={{ cursor: "pointer", color: "#323232" }}
          onClick={onClose}
        />
      </Header>

      <StickyTabsContainer>
        <TabsWrapper isBuilderHotbar>
          <TabNavigation activeTab={activeTab} onChangeTab={setActiveTab} />
        </TabsWrapper>
      </StickyTabsContainer>

      <ScrollableContent>
        <Content>{renderTabContent()}</Content>
      </ScrollableContent>
    </Container>
  );
};

export default HotbarBuilder;
